<template>
  <div class="KPI_compo">
    <div
      v-if="columns.length > 0"
      class="main"
    >
      {{ getKpiData(columns[0]) }}
      <span
        v-if="useSubIndicator"
        class="subtit"
      >
        {{ getKpiData(columns[1]) }}
      </span>
    </div>
    <div
      v-if="columns.length > 3"
      class="row"
    >
      <div
        v-for="index in Math.floor(Number(columns.length) / 3)"
        :key="index"
        class="sub"
      >
        <div class="top">
          <div class="tit">
            {{ relatedIndicatorTitleList[index - 1] }}
          </div>
        </div>
        <div class="bottom">
          <div class="num pr-2">
            {{ getRelatedKpiData(index, 0) }}
          </div>

          <div class="nums">
            {{ getRelatedKpiData(index, 1) }}
          </div>
          <span :class="getRelatedKpiClass(index)">
            {{ getRelatedKpiData(index, 2) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SuiKpiBoard',
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    relatedIndicatorTitleList: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    selectedData() {
      if (this.data.length > 0) {
        return this.data[0];
      }

      return {};
    },

    useSubIndicator() {
      return this.columns.length % 3 === 2;
    },

    firstRelatedIndex() {
      return this.useSubIndicator ? 2 : 1;
    },
  },

  methods: {
    getKpiData(attributeId) {
      let value = this.selectedData[attributeId];
      let unit = '';
      if (value > 99999999999) {
        value /= 1000000000;
        unit = 'G';
      } else if (value > 99999999) {
        value /= 1000000;
        unit = 'M';
      } else if (value > 99999) {
        value /= 1000;
        unit = 'K';
      }
      value = value.toFixed(0);

      value = utils.numberFormat(value) + unit;
      return value;
    },
    getRelatedKpiData(relatedIndex, num) {
      const attributeId = this.columns[(relatedIndex - 1) * 3 + this.firstRelatedIndex + num];
      let value = parseFloat(this.selectedData[attributeId], 10);
      let unit = '';
      if (num === 2) {
        value *= 100;
        value = value.toFixed(2);
        unit = '%';
      } else {
        if (Math.abs(value) > 99999999999) {
          value /= 1000000000;
          unit = 'G';
        } else if (Math.abs(value) > 99999999) {
          value /= 1000000;
          unit = 'M';
        } else if (Math.abs(value) > 99999) {
          value /= 1000;
          unit = 'K';
        }
        value = value.toFixed(0);
      }

      value = utils.numberFormat(value) + unit;
      return value;
    },
    getRelatedKpiClass(relatedIndex) {
      const attributeId = this.columns[(relatedIndex - 1) * 3 + this.firstRelatedIndex + 2];
      const value = parseFloat(this.selectedData[attributeId], 10);
      if (Number(value) >= 0) {
        return 'arrow_BL';
      }

      return 'arrow_RE';
    },
  },
};
</script>

<style scoped>
</style>
